module.exports = __webpack_public_path__ + "static/media/CU.41346d9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CU.svg
// module id = 2134
// module chunks = 7